import { FrequencyConfig } from 'common/types/frequencySelector/frequencySelector';
import { RequiredFieldsStatus } from '../types/scheduleSend';

export const frequencyConfigDefaulValues: FrequencyConfig = {
  intervalInfo: {
    count: 1,
    type: 'day',
  },
  timeInfo: {
    timeZone: 'pst',
  },
  datesInfo: {
    hasEndDate: false,
  },
};

export const requiredFieldsStatusDefaultValues: RequiredFieldsStatus = {
  isFrequencyTimeInvalid: false,
  isFrequencyStartDateInvalid: false,
  isFrequencyEndDateInvalid: false,
  isRecipientEmptyUponSaving: false,
  isIntervalInvalid: false,
};
